import { DataTableFilterBarV2Component, dataTableFilterBarV2Template } from './DataTableFilterBarV2';
import styles from './DataTableFilterBarV2.styles.scss';
export const chameleonDataTableFilterBarV2 = DataTableFilterBarV2Component.compose({
    baseName: 'data-table-filter-bar-v2',
    template: dataTableFilterBarV2Template,
    styles,
});
